module.exports = __webpack_public_path__ + "img/cover-minigame-bg.c53a0d07.jpg";